export default __webpack_public_path__ + "static/media/gallery_01.36af75d0.jpg";